import React from 'react';
import { useHistory } from 'react-router-dom';
import { useOnlineStatus } from '../../hooks/onlineStatus';

import { IconArrowLeft, IconInfoCircle } from '@tabler/icons';

import { Container, Title, Button, OfflineBar } from './styles';

interface HeaderProps {
  title?: string;
}

const Header: React.FC<HeaderProps> = ({ title, children }) => {
  const history = useHistory();
  const isOnline = useOnlineStatus();

  return (
    <>
      <Container>
        <div>
          <Button onClick={() => history.goBack()}>
            <IconArrowLeft size={30} />
          </Button>
          <Title>{title}</Title>
        </div>

        <div>{children}</div>
      </Container>

      {!isOnline ? (
        <>
          <OfflineBar>
            <IconInfoCircle size={16} style={{ marginRight: 10 }} />
            Sem conexão
          </OfflineBar>
          <div style={{ height: 95 }} />
        </>
      ) : (
        <div style={{ height: 70 }} />
      )}
    </>
  );
};

export default Header;
